import ApiResource from './ApiResource';

class FacebookResource extends ApiResource<any> {
  public endpoint = '/facebook_login_check';
}

export const facebookResource = new FacebookResource();
